<template>
  <el-card class="h-full">
    <div class="h-full relative">
      <el-tabs v-model="activeName">
        <el-tab-pane label="设备设施类" name="equip">
          <task-equip-table v-if="activeName === 'equip'"></task-equip-table>
        </el-tab-pane>
        <el-tab-pane label="作业活动类" name="job">
          <task-job-table v-if="activeName === 'job'"></task-job-table>
        </el-tab-pane>
        <el-tab-pane label="基础管理类" name="base">
          <task-base-table v-if="activeName === 'base'"></task-base-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-card>
</template>

<script>
import TaskEquipTable from '../components/OverdueTask/OverdueTaskEquipTable'
import TaskBaseTable from '../components/OverdueTask/OverdueTaskBaseTable'
import TaskJobTable from '../components/OverdueTask/OverdueTaskJobTable'

export default {
  name: 'trouble-shoot-overdue-task',
  components: {
    TaskEquipTable,
    TaskBaseTable,
    TaskJobTable,
  },
  data() {
    return {
      activeName: 'equip',
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 54px) !important;
  position: inherit;
  .el-tab-pane {
    height: 100%;
  }
}
</style>
